import React, { useCallback, useEffect, useState } from 'react';
import {
  FlexWrapper,
  GrapBox,
  HighlightText,
  PaginationBox,
  ViewIconBox
} from '../../theme/common_style';
import { Button, Drawer, Pagination, Table } from 'antd';
import { ViewIconNew } from '../../theme/SvgIcons';
import {
  checkPermission,
  debounce,
  generateEmployeeImgUrl,
  getFullName,
  useWindowWide
} from '../../utils/common_functions';
import { useDispatch, useSelector } from 'react-redux';
import SearchField from '../../components/searchField/SearchField';
import TableLoader from '../../components/loaders/TableLoader';
import CreateEmployees from './CreateEmployees';
import ActivityEmployee from './ActivityEmployee';
import UploadEmployee from './UploadEmployee';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getEmployeeApi, getTotalEmployeesGraph } from '../../redux/employee/apiRoute';
import FilterDrawer from './FilterDrawer';
import { updateActivityDrawer } from '../../redux/sidebar/SidebarSlice';
import { StickyBox } from '../../utils/style';
import { AvatarGroup } from '../../components/common/AvatarGroup';
import FilterButton from '../../components/common/FilterButton';
import { useCurrentModule } from '../../hooks/useCurrentModule';
import ProjectsListingModal from '../../components/Modal/ProjectListingModal';
import BarGraph from '../../components/common/BarGraph';

const Employees = () => {
  const { permissions } = useSelector((state) => state?.userInfo?.data);
  const moduleName = useCurrentModule();
  const canCreate = checkPermission(moduleName, 'create', permissions);
  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const navigate = useNavigate();
  const [search, setSearch] = useState(null);
  const [filterDrawer, setFilterDrawer] = useState(false);
  const appliedFilter = useSelector((state) => state?.employeeSlice?.filterData);
  const activityDrawer = useSelector((state) => state?.sidebar?.isActivityDrawer);
  const dispatch = useDispatch();
  const [sort, setSort] = useState({});
  const [projectList, setProjectList] = useState(false);
  const [projectListData, setProjectListData] = useState([]);

  const mediumScreen = useWindowWide(600);

  const handleSorting = (val) => {
    if (val?.field) {
      let order = val?.order == 'ascend' ? 'ASC' : 'DESC';
      setSort({ sortBy: val?.field, orderBy: order, ...val });
    } else {
      setSort({});
    }
    setPage(page);
  };

  const columns = [
    {
      title: 'S.NO',
      dataIndex: 'key',
      key: 'key',
      render: (text) => <span>{(page - 1) * limit + text}.</span>
    },
    {
      title: 'Emp Name',
      dataIndex: 'first_name',
      key: 'user',
      sorter: true,
      render: (_, data) => {
        const empName = getFullName(data?.first_name, data?.middle_name, data?.last_name);
        const empData = [
          {
            name: empName,
            src: generateEmployeeImgUrl(data?.id),
            id: data?.id,
            completionColor: data?.profile_completion
          }
        ];
        return (
          <FlexWrapper
            justify={'start'}
            gap={'6px'}
            wrap={'unset'}
            onClick={() =>
              navigate(`/view-employee`, {
                state: { name: empName, id: data?.id }
              })
            }>
            <AvatarGroup avatars={empData} />
            <HighlightText>{empName}</HighlightText>
          </FlexWrapper>
        );
      }
    },
    {
      title: 'Emp Code',
      dataIndex: 'emp_code',
      key: 'emp_code',
      sorter: true
    },
    {
      title: 'Designation',
      dataIndex: 'designation',
      key: 'designation',
      sorter: true,
      render: (designation) => <span>{designation || 'N/A'}</span>
    },
    {
      title: 'Department',
      dataIndex: 'department',
      key: 'department',
      sorter: true,
      render: (department) => <span>{department || 'N/A'}</span>
    },
    {
      title: 'No of Projects',
      dataIndex: 'projectcount',
      key: 'projectcount',
      render: (count, data) => {
        const projectsData = data?.employeeAssignee?.map((el) => el?.project_id) || [];
        return (
          <div
            style={{ fontWeight: '500', textAlign: 'center' }}
            onClick={() => {
              if (projectsData?.length > 0) {
                setProjectList(true);
                setProjectListData(projectsData);
              }
            }}>
            {projectsData?.length > 0 ? (
              <span style={{ cursor: 'pointer' }}>{count}</span>
            ) : (
              <span>N/A</span>
            )}
          </div>
        );
      }
    },
    // {
    //   title: 'Status',
    //   dataIndex: 'status',
    //   key: 'status',
    //   render: (status) => {
    //     return (
    //       <FlexWrapper
    //         width="fit-content"
    //         style={{
    //           backgroundColor: `${status === 'active' ? '#FAFFDE' : '#FFDEE6'}`,
    //           padding: '6px 12px',
    //           color: `${status === 'active' ? '#5EB85C' : '#FB4A49'}`,
    //           textWrap: 'nowrap',
    //           borderRadius: '100px',
    //           fontSize: '12px'
    //         }}>
    //         {status}
    //       </FlexWrapper>
    //     );
    //   }
    // },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      className: 'action-column',
      render: (_, record) => {
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="pointer">
            <ViewIconBox
              onClick={() =>
                navigate(`/view-employee`, {
                  state: {
                    name: getFullName(record?.first_name, record?.middle_name, record?.last_name),
                    id: record?.id
                  }
                })
              }>
              <ViewIconNew />
            </ViewIconBox>
          </FlexWrapper>
        );
      }
    }
  ];
  const handlePageChange = (page) => {
    setPage(page);
  };

  const handleGetAllEmployees = async (search) => {
    try {
      setLoading(true);
      const params = new URLSearchParams({ page, limit, ...(search && { search }) });
      sort?.sortBy && params.append('column_name', sort?.sortBy);
      sort?.orderBy && params.append('column_order', sort?.orderBy);
      Object.entries(appliedFilter || {}).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value?.length > 0 && params.append(key, value);
        } else {
          value && params.append(key, value);
        }
      });

      const res = await getEmployeeApi(params);
      if (res?.statusCode === 200) {
        setTotal(res?.data?.total);
        setDataSource(
          res?.data?.list?.map((el, idx) => ({
            ...el,
            key: idx + 1,
            role: el?.role_id?.role
          }))
        );
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const optimizedFn = useCallback(debounce(handleGetAllEmployees), [appliedFilter, sort, page]);

  useEffect(() => {
    if (search !== null) {
      optimizedFn(search);
    } else {
      handleGetAllEmployees();
    }
  }, [search, page, appliedFilter, sort]);

  return (
    <div style={{ position: 'relative' }}>
      {projectList && (
        <ProjectsListingModal
          open={projectList}
          onClose={() => {
            setProjectList(false);
            setProjectListData([]);
          }}
          data={projectListData}
        />
      )}
      {filterDrawer && <FilterDrawer open={filterDrawer} onClose={() => setFilterDrawer(false)} />}
      {uploadModal && <UploadEmployee open={uploadModal} onClose={() => setUploadModal(false)} />}
      {activityDrawer && (
        <Drawer
          width={490}
          title="Activity"
          placement="right"
          closable
          prefixCls="activityCustomDrawer"
          onClose={() => dispatch(updateActivityDrawer(false))}
          open={activityDrawer}>
          <ActivityEmployee />
        </Drawer>
      )}
      {createModal && (
        <CreateEmployees
          open={createModal}
          onClose={() => setCreateModal(false)}
          handleGetAllEmployees={handleGetAllEmployees}
        />
      )}
      <GrapBox width="900px">
        <div className="chart-wrapper">
          <BarGraph title="Total Employees" api={getTotalEmployeesGraph} />
        </div>
      </GrapBox>
      <StickyBox>
        <FlexWrapper width="100%" justify={canCreate ? 'space-between' : 'end'} gap="16px">
          {canCreate && (
            <Button prefixCls="antCustomBtn" onClick={() => setCreateModal(true)}>
              + Add New Employee
            </Button>
          )}
          <FlexWrapper justify="end" gap="6px" width={mediumScreen ? 'fit-content' : '100%'}>
            <SearchField
              placeholder="Search by Emp Name..."
              width="250px"
              onChange={(val) => {
                setSearch(val);
                setPage(1);
              }}
              allowClear
              value={search}
            />
            <FilterButton handleClick={setFilterDrawer} appliedFilter={appliedFilter} />
          </FlexWrapper>
        </FlexWrapper>
      </StickyBox>
      <Table
        prefixCls="antCustomTable"
        columns={columns}
        dataSource={dataSource || []}
        pagination={false}
        loading={{ spinning: loading, indicator: TableLoader }}
        onChange={(_, filters, sorter) => {
          handleSorting(sorter);
        }}
        defaultSortOrder={sort.order}
      />
      {total > limit && (
        <PaginationBox>
          <Pagination
            current={page}
            prefixCls="custom-pagination"
            pageSize={limit}
            total={total}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
        </PaginationBox>
      )}
    </div>
  );
};

export default Employees;
